import React from 'react';

import { UiSelect } from '../../ui/ui-select';

import { isValueANumber } from '../../util/number-utils';
import { PRICING_VERSION } from '../utils/pricing-version';

type InputProps = {
  accountPricingVersionId: number;
  selectedPricingVersionId: number;
  setSelectedPricingVersionId: (pricingVersionId: number) => void;
};

export const PricingVersionSelector = (props: InputProps) => {
  const { accountPricingVersionId, selectedPricingVersionId, setSelectedPricingVersionId } = props;

  const handleChangePricingVersion = (pricingVersion: string) => {
    const pricingVersionId = isValueANumber(pricingVersion) ? parseInt(pricingVersion, 10) : null;
    if (pricingVersionId) {
      setSelectedPricingVersionId(pricingVersionId);
    }
  };

  // Because both V1 and V2 are handled by the same component, we could have either value
  // If they are on V1, the options will be V1 or V3. If they are V2 or V3, those are the options.
  const singlePriceVersionId = accountPricingVersionId === PRICING_VERSION.V1 ? '1' : '2';

  return (
    <UiSelect
      label="Pricing Version"
      value={selectedPricingVersionId.toString()}
      onChange={handleChangePricingVersion}
      options={[
        {
          label: 'Single-Price Subscription',
          value: singlePriceVersionId,
        },
        {
          label: 'Itemized Subscription',
          value: '3',
        },
      ]}
    />
  );
};
